import {z} from '@hono/zod-openapi';

export const priceReportArgumentsParamsSchema = z
  .object({
    reportId: z
      .string()
      .uuid()
      .openapi({
        param: {name: 'reportId', in: 'path'},
        example: '7a18b55c-a640-4274-bb8f-96b30135200e',
      }),
  })
  .openapi('PriceReportArgumentsParams');
